import { Link } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';
import Button from '@/components/ui/Button';

export default function NotFoundPage() {
  return (
    <PageLayout>
      <div className="section-padding bg-white dark:bg-secondary-900 min-h-[60vh] flex items-center">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            <div className="mb-8">
              <h1 className="text-9xl font-bold text-primary-600 dark:text-primary-400 mb-4">
                404
              </h1>
              <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 dark:text-white mb-4">
                Page Not Found
              </h2>
              <p className="text-lg text-secondary-600 dark:text-secondary-400">
                Sorry, we couldn't find the page you're looking for. It might have been moved or
                deleted.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button size="lg">Go to Homepage</Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" size="lg">
                  Contact Support
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}

